module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-6-3c96e9e02b19eb11f2a92c057eb27bcc.svg";